<template>
  <basic-info-lottie-banner compact hide-right-orb>
    <div class="zipPackageRequirement">
      <p class="zipPackageRequirement__title">zip 包要求</p>

      <div class="zipPackageRequirement__strip zipPackageRequirement__strip--cols-3">
        <div
          v-for="section in sections"
          :key="section.key"
          class="zipPackageRequirement__seg"
        >
          <p class="zipPackageRequirement__label">
            {{ section.title }}
            <span v-if="section.showNamingLegend" class="zipPackageRequirement__legend">
              <span
                v-if="section.requiredColumn && section.requiredColumn.length"
                class="zipPackageRequirement__badge zipPackageRequirement__badge--required"
              >必传</span>
              <span
                v-if="section.optionalColumn && section.optionalColumn.length"
                class="zipPackageRequirement__badge zipPackageRequirement__badge--optional"
              >非必传</span>
            </span>
          </p>

          <div
            v-if="section.listMode === 'req-opt-split'"
            class="zipPackageRequirement__reqOptNaming"
            :class="{
              'zipPackageRequirement__reqOptNaming--single': isReqOptSingleColumn(section),
            }"
          >
            <ul
              v-if="section.requiredColumn && section.requiredColumn.length"
              class="zipPackageRequirement__list zipPackageRequirement__list--requiredCol"
            >
              <li
                v-for="item in section.requiredColumn"
                :key="section.key + '-req-' + item.text"
                class="zipPackageRequirement__item zipPackageRequirement__item--required"
              >
                <!-- 必传/非必传只靠红框/灰虚线样式；字样仅保留标题旁图例 -->
                <span class="zipPackageRequirement__itemText">{{ item.text }}</span>
              </li>
            </ul>
            <ul
              v-if="section.optionalColumn && section.optionalColumn.length"
              class="zipPackageRequirement__list zipPackageRequirement__list--optionalCol"
            >
              <li
                v-for="item in section.optionalColumn"
                :key="section.key + '-opt-' + item.text"
                class="zipPackageRequirement__item zipPackageRequirement__item--optional"
              >
                <span class="zipPackageRequirement__itemText">{{ item.text }}</span>
              </li>
            </ul>
          </div>

          <ul
            v-else-if="section.items.length"
            class="zipPackageRequirement__list"
            :class="{
              'zipPackageRequirement__list--example': section.listMode === 'example',
              'zipPackageRequirement__list--columns2': section.listMode === 'columns-2',
            }"
          >
            <li
              v-for="item in section.items"
              :key="section.key + '-' + item.text"
              class="zipPackageRequirement__item"
            >
              {{ item.text }}
            </li>
          </ul>

          <p v-else class="zipPackageRequirement__empty">—</p>
        </div>
      </div>
    </div>
  </basic-info-lottie-banner>
</template>

<script>
import BasicInfoLottieBanner from './BasicInfoLottieBanner.vue'
import { buildZipPackageSections } from './zipPackageRequirementLayout'
import './zipPackageRequirement.css'

export default {
  name: 'ZipPackageRequirement',
  components: { BasicInfoLottieBanner },
  props: {
    spec: {
      type: Object,
      default: () => ({ includes: [], exact: [], pattern: [], optional: [], examples: [] }),
    },
    assetType: {
      type: String,
      default: '',
    },
  },
  computed: {
    sections() {
      return buildZipPackageSections(this.spec, this.assetType)
    },
  },
  methods: {
    /** 必传/非必传只剩一列时改单列，避免空半边 */
    isReqOptSingleColumn(section) {
      const reqLen = (section.requiredColumn && section.requiredColumn.length) || 0
      const optLen = (section.optionalColumn && section.optionalColumn.length) || 0
      return reqLen === 0 || optLen === 0
    },
  },
}
</script>
